import { render, staticRenderFns } from "./MembershipGroupPrivilegeRegistration.vue?vue&type=template&id=4ff1eec6&scoped=true&"
import script from "./MembershipGroupPrivilegeRegistration.vue?vue&type=script&lang=js&"
export * from "./MembershipGroupPrivilegeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MembershipGroupPrivilegeRegistration.vue?vue&type=style&index=0&id=4ff1eec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1eec6",
  null
  
)

export default component.exports